const i18n = {
  'en-US': {
    'public.action.title': 'Action',
    'public.action.ok': 'OK',
    'public.action.cancel': 'Cancel',
    'public.action.confirm': 'Confirm',
    'public.action.submit': 'Submit',
    'public.action.reset': 'Reset',
    'public.action.search': 'Search',
    'public.action.refresh': 'Refresh',
    'public.action.upload': 'Upload',
    'public.action.import': 'Import',
    'public.action.export': 'Export',
    'public.action.print': 'Print',
    'public.action.print.draft': 'Print Draft',
    'public.action.download': 'Download',
    'public.action.template': 'Template',
    'public.action.open': 'Open',
    'public.action.create': 'Create',
    'public.action.add': 'Add',
    'public.action.delete': 'Delete',
    'public.action.edit': 'Edit',
    'public.action.view': 'View',
    'public.action.publish': 'Publish',
    'public.action.revoke': 'Revoke',
    'public.action.agree': 'Agree',
    'public.action.reject': 'Reject',
    'public.action.approve': 'Approve',
    'public.action.decline': 'Decline',
    'public.action.start': 'Start',
    'public.action.pause': 'Pause',
    'public.action.resume': 'Resume',
    'public.action.lock': 'Lock',
    'public.action.unlock': 'Unlock',
    'public.action.close': 'Close',
    'public.action.complete': 'Complete',
    'public.action.save': 'Save',
    'public.action.copy': 'Copy',
    'public.action.paste': 'Paste',
    'public.action.revise': 'Revise',
    'public.action.change': 'Change',
    'public.action.archive': 'Archive',
    'public.action.derive': 'Derive',
    'public.action.inactive': 'Inactive',
    'public.action.active': 'Active',
    'public.action.inquiry': 'Inquiry',
    'public.action.quote': 'Quote',
    'public.action.delivery': 'Delivery',
    'public.action.move': 'Move',
    'public.action.bind': 'Bind',
    'public.action.unbind': 'Unbind',
    'public.action.pick': 'Pick',
    'public.action.default': 'Default',
    'public.action.use.this': 'Use This',
    'public.action.add.items': 'Add Items',
    'public.action.issue': 'Issue',
    'public.action.switch': 'Switch',
    'public.action.cancel.description': 'Are you sure you want to cancel it?',
    'public.action.delete.description': 'Are you sure you want to delete it?',
    'public.action.approve.description': 'Are you sure you want to approve it?',
    'public.action.decline.description': 'Are you sure you want to decline it?',
    'public.action.agree.description': 'Are you sure you want to agree it?',
    'public.action.reject.description': 'Are you sure you want to reject it?',
    'public.action.publish.description': 'Are you sure you want to publish it?',
    'public.action.revoke.description': 'Are you sure you want to revoke it?',
    'public.action.start.description': 'Are you sure you want to start it?',
    'public.action.pause.description': 'Are you sure you want to pause it?',
    'public.action.resume.description': 'Are you sure you want to resume it?',
    'public.action.lock.description': 'Are you sure you want to lock it?',
    'public.action.unlock.description': 'Are you sure you want to unlock it?',
    'public.action.close.description': 'Are you sure you want to close it?',
    'public.action.complete.description': 'Are you sure you want to complete it?',
    'public.action.confirm.description': 'Are you sure you want to confirm it?',
    'public.msg.upload.success': 'Upload success',
    'public.msg.upload.failed': 'Upload failed',
    'public.label.yes': 'Yes',
    'public.label.no': 'No',
    'public.label.help': 'Help',
    'public.label.instruction': 'Instruction',
    'public.label.corporate': 'Corporate',
    'public.label.department': 'Department',
    'public.label.role': 'Role',
    'public.label.name': 'Name',
    'public.label.email': 'Email',
    'public.label.phone': 'Phone',
    'public.label.large': 'Large',
    'public.label.middle': 'Medium',
    'public.label.small': 'Small',
    'public.label.field': 'Field',
    'public.label.detail': 'Detail',
    'public.label.index': 'Index',
    'public.label.initiator': 'Initiator',
    'public.label.required': 'Required',
    'public.label.priority': 'Priority',
    'public.label.success': 'Success',
    'public.label.lowest': 'Lowest',
    'public.label.low': 'Low',
    'public.label.medium': 'Medium',
    'public.label.high': 'High',
    'public.label.highest': 'Highest',
    'public.label.count': 'Count',
    'public.label.progress': 'Progress',
    'public.label.source': 'Source',
    'public.label.target': 'Target',
    'public.label.warehouse': 'Warehouse',
    'public.label.zone': 'Zone',
    'public.label.basket': 'Basket',
    'public.label.lot_no': 'Lot No',
    'public.label.counting': 'Counting',
    'public.label.group': 'Group',
    'public.label.mine': 'Mine',
    'public.label.super_admin': 'Super Admin',
    'public.label.stock': 'Stock',
    'public.label.stock_aging': 'Aging (Days)',
    'public.label.stock_flow': 'Stock Flow',
    'public.label.keyword': 'Keyword',
    'public.label.approval': 'Approval',
    'public.label.approval_detail': 'Approval Detail',
    'public.label.usage': 'Usage',
    'public.label.payment': 'Payment',
    'public.label.change': 'Change',
    'public.label.summary': 'Summary',
    'public.label.statistics': 'Statistics',
    'public.label.app': 'App',
    'public.label.subject': 'Subject',
    'public.label.bom_subject': 'BOM Subject',
    'public.label.component': 'Component',
    'public.label.completed': 'Completed',
    'public.label.change_type': 'Change',
    'public.label.start_date': 'Start Date',
    'public.label.end_date': 'End Date',
    'public.label.request_date': 'Request Date',
    'public.label.owner': 'Owner',
    'public.label.creator': 'Creator',
    'public.label.operator': 'Operator',
    'public.label.confirmer': 'Confirmer',
    'public.label.contact': 'Contact',
    'public.label.recipient': 'Recipient',
    'public.label.consignee': 'Consignee',
    'public.label.receiver': 'Receiver',
    'public.label.deliverer': 'Deliverer',
    'public.label.inspector': 'Inspector',
    'public.label.supplier': 'Supplier',
    'public.label.purchaser': 'Purchaser',
    'public.label.customer': 'Customer',
    'public.label.party_name': 'Supplier/Customer',
    'public.label.receiver_party': 'Receiver Party',
    'public.label.customer_name': 'Customer Name',
    'public.label.creator_phone': 'Creator Phone',
    'public.label.contact_phone': 'Contact Phone',
    'public.label.consignee_phone': 'Consignee Phone',
    'public.label.ship.address': 'Ship‑to Address',
    'public.label.address_label': 'Address Label',
    'public.label.print_count': 'Print Count',
    'public.label.purchase_type': 'Purchase Type',
    'public.label.purchase': 'Purchase',
    'public.label.produce': 'Produce',
    'public.label.supplier_name': 'Supplier Name',
    'public.label.short_name': 'Short Name',
    'public.label.level': 'Level',
    'public.label.currency': 'Currency',
    'public.label.payment_method': 'Payment Method',
    'public.label.payment_term': 'Payment Term',
    'public.label.tax_rate': 'Tax Rate',
    'public.label.amount': 'Amount',
    'public.label.tax': 'Tax',
    'public.label.total_amount': 'Total Amount',
    'public.label.total_grand': 'Total',
    'public.label.fee': 'Fee',
    'public.label.invoice': 'Invoice',
    'public.label.advance': 'Advance',
    'public.label.statement': 'Statement',
    'public.label.report': 'Report',
    'public.label.cost': 'Cost',
    'public.label.profit': 'Profit',
    'public.label.margin': 'Margin',
    'public.label.unit_price': 'Unit Price',
    'public.label.allocation': 'Allocation',
    'public.label.cost.manufacturing': 'Manufacturing Cost',
    'public.label.cost.labor': 'Labor Cost',
    'public.label.cost.material': 'Material Cost',
    'public.label.cost.total': 'Total Cost',
    'public.label.cost.unit': 'Unit Cost',
    'public.label.fiscal.period': 'Fiscal Period',
    'public.label.contract_date': 'Contract Date',
    'public.label.feedback_date': 'Feedback Date',
    'public.label.action_date': 'Action Due Date',
    'public.label.required_date': 'Required Date',
    'public.label.delivery_date': 'Delivery Date',
    'public.label.inbound_date': 'Inbound Date',
    'public.label.outbound_date': 'Outbound Date',
    'public.label.date': 'Date',
    'public.label.days': 'Days',
    'public.label.work_ticket': 'Work Ticket',
    'public.label.sub_work_ticket': 'Sub Work Ticket',
    'public.label.bom_version': 'BOM Version',
    'public.label.finished_product': 'Finished Product',
    'public.label.line_material': 'Line-side Material',
    'public.label.line_issue': 'Line Issue',
    'public.label.line_return': 'Line Return',
    'public.label.supplement': 'Supplement',
    'public.label.old_qty': 'Old Qty',
    'public.label.new_qty': 'New Qty',
    'public.label.required_qty': 'Required Qty',
    'public.label.bidding_qty': 'Bidding Qty',
    'public.label.order_qty': 'Order Qty',
    'public.label.pending_qty': 'Pending Qty',
    'public.label.total_qty': 'Total Qty',
    'public.label.quantity': 'Quantity',
    'public.label.opening_qty': 'Opening Qty',
    'public.label.change_qty': 'Change Qty',
    'public.label.closing_qty': 'Closing Qty',
    'public.label.accept_qty': 'Accept Qty',
    'public.label.remaining_qty': 'Remaining Qty',
    'public.label.open_issue_qty': 'Open Issue Qty',
    'public.label.un_dispatched_qty': 'Un dispatched Qty',
    'public.label.dispatching_qty': 'Dispatching Qty',
    'public.label.delivered_qty': 'Delivered Qty',
    'public.label.return_pending_qty': 'Pending Return Qty',
    'public.label.returned_qty': 'Returned Qty',
    'public.label.dispatchable_qty': 'Dispatchable Qty',
    'public.label.received_qty': 'Received Qty',
    'public.label.return_qty': 'Return Qty',
    'public.label.inspect_qty': 'Inspect Qty',
    'public.label.pass_qty': 'Pass Qty',
    'public.label.fail_qty': 'Fail Qty',
    'public.label.defect_qty': 'Defect Qty',
    'public.label.reserved_qty': 'Reserved Qty',
    'public.label.stock_qty': 'Stock Qty',
    'public.label.ready_dispatch_qty': 'Ready to Dispatch Qty',
    'public.label.ready_issue_qty': 'Ready to Issue Qty',
    'public.label.pick_qty': 'Pick Qty',
    'public.label.usage_qty': 'Usage Qty',
    'public.label.shortage_qty': 'Shortage Qty',
    'public.label.inbound_qty': 'Inbound Qty',
    'public.label.issued_qty': 'Issued Qty',
    'public.label.line_qty': 'Line Qty',
    'public.label.pending_issue_qty': 'Pending Issue Qty',
    'public.label.shipped_qty': 'Shipped Qty',
    'public.label.pending_ship_qty': 'Pending Ship Qty',
    'public.label.plan_qty': 'Plan Qty',
    'public.label.rework_qty': 'Rework Qty',
    'public.label.net_output_qty': 'Net Output Qty',
    'public.label.produce_qty': 'Produce Qty',
    'public.label.purchase_qty': 'Purchase Qty',
    'public.label.safe_qty': 'Safe Qty',
    'public.label.locked_qty': 'Locked Qty',
    'public.label.system_qty': 'System Qty',
    'public.label.actual_qty': 'Actual Qty',
    'public.label.diff_qty': 'Diff Qty',
    'public.label.actual_usage_qty': 'Actual Usage Qty',
    'public.label.price': 'Price',
    'public.label.edit_price': 'Edit Price',
    'public.label.preset_price': 'Preset Price',
    'public.label.unit_price_excl_tax': 'Unit Price (Excl. Tax)',
    'public.label.unit_price_incl_tax': 'Unit Price (Incl. Tax)',
    'public.label.tier_price': 'Tiered Price',
    'public.label.min_qty': 'Min Qty',
    'public.label.max_qty': 'Max Qty',
    'public.label.moq': 'MOQ',
    'public.label.min_lead_time': 'Min Lead Time',
    'public.label.lead_time': 'Lead Time',
    'public.label.tier_count': 'Tier Count',
    'public.label.comparison': 'Comparison',
    'public.label.bidding': 'Bidding',
    'public.label.inquiry': 'Inquiry',
    'public.label.quote': 'Quote',
    'public.label.latest_unit_price': 'Latest Unit Price',
    'public.label.min_unit_price': 'Min Unit Price',
    'public.label.latest_trans': 'Latest',
    'public.label.min_price': 'Min Price',
    'public.label.countdown': 'Countdown',
    'public.label.deadline': 'Deadline',
    'public.label.due_date': 'Due Date',
    'public.label.change_reason': 'Change Reason',
    'public.label.return_reason': 'Return Reason',
    'public.label.version': 'Version',
    'public.label.target_version': 'Target Version',
    'public.label.version_history': 'Version History',
    'public.label.labels': 'Labels',
    'public.label.remark': 'Remark',
    'public.label.status': 'Status',
    'public.label.title': 'Title',
    'public.label.content': 'Content',
    'public.label.context': 'Context',
    'public.label.ip': 'IP',
    'public.label.description': 'Description',
    'public.label.delivery_plan': 'Delivery Plan',
    'public.label.biz_type': 'Business Type',
    'public.label.biz_no': 'Business No',
    'public.label.plan': 'Plan',
    'public.label.items': 'Items',
    'public.label.materials': 'Material Items',
    'public.label.contract': 'Contract',
    'public.label.ecn_no': 'ECN No',
    'public.label.ticket_no': 'Ticket No',
    'public.label.contract_no': 'Contract No',
    'public.label.request_no': 'Request No',
    'public.label.order_no': 'Purchase Order No',
    'public.label.delivery_no': 'Delivery No',
    'public.label.return_no': 'Return No',
    'public.label.inspect_no': 'Inspect No',
    'public.label.inbound_no': 'Inbound No',
    'public.label.outbound_no': 'Outbound No',
    'public.label.payment_no': 'Payment No',
    'public.label.invoice_no': 'Invoice No',
    'public.label.statement_title': 'Statement Title',
    'public.label.change_log': 'Change Log',
    'public.label.sales_order_no': 'Sales Order No',
    'public.label.link_no': 'Link No',
    'public.label.start_time': 'Start Time',
    'public.label.end_time': 'End Time',
    'public.label.created_time': 'Created Time',
    'public.label.updated_time': 'Updated Time',
    'public.label.confirmed_time': 'Confirmed Time',
    'public.label.inspected_time': 'Inspected Time',
    'public.label.change_time': 'Change Time',
    'public.label.expire_date': 'Expire Date',
    'public.label.expire_time': 'Expire Time',
    'public.label.operated_time': 'Operated Time',
    'public.label.delay': 'Delay',
    'public.label.pending.delivery': 'Pending Delivery',
    'public.label.delivery': 'Delivery',
    'public.label.receipt': 'Receipt',
    'public.label.receipt.history': 'Receipt History',
    'public.label.return': 'Return',
    'public.label.return.history': 'Return History',
    'public.label.inspect': 'Inspection',
    'public.label.inspect.history': 'Inspect History',
    'public.label.inspect.result': 'Inspect Result',
    'public.label.reinspect': 'Re-inspect',
    'public.label.defect.type': 'Defect Type',
    'public.label.defect.desc': 'Defect Description',
    'public.label.defect.images': 'Defect Images',
    'public.label.defect.report': 'Defect Report',
    'public.label.inbound': 'Inbound',
    'public.label.inbound.history': 'Inbound History',
    'public.label.outbound': 'Outbound',
    'public.label.outbound.history': 'Outbound History',
    'public.label.inbound.type': 'Inbound Type',
    'public.label.outbound.type': 'Outbound Type',
    'public.label.order.purchase': 'Purchase Order',
    'public.label.order.delivery': 'Delivery Order',
    'public.label.order.return': 'Return Order',
    'public.label.order.inspect': 'Inspect Order',
    'public.label.order.inbound': 'Inbound Order',
    'public.label.order.outbound': 'Outbound Order',
    'public.label.order.payment': 'Payment Order',
    'public.label.order.statement': 'Statement Order',
    'public.label.order.sales': 'Sales Order',
    'public.label.order.request': 'Request Order',
    'public.label.order.index': 'Order Index',
    'public.label.supplier_label': 'Supplier Label',
    'public.label.consolidate': 'Consolidate',
    'public.label.deconsolidate': 'Deconsolidate',
    'public.label.category': 'Category',
    'public.label.material': 'Material',
    'public.label.substitute': 'Substitute',
    'public.label.material.diff': 'Material Difference',
    'public.label.material_code': 'Material Code',
    'public.label.material_name': 'Material Name',
    'public.label.material_spec': 'Spec. / Drawing',
    'public.label.material_brand': 'Type / Brand',
    'public.label.material_unit': 'Unit',
    'public.label.material_version': 'Material Version',
    'public.label.referenced_version': 'Referenced Version',
    'public.label.drawing': 'Drawing',
    'public.label.drawing_version': 'Drawing Version',
    'public.label.customer.material_code': 'Customer Material Code',
    'public.label.customer.material_name': 'Customer Material Name',
    'public.label.difference': 'Difference',
    'public.label.new': 'New',
    'public.label.deactivated': 'Deactivated',
    'public.label.activated': 'Activated',
    'public.label.enable_mrp': 'Enable MRP',
    'public.label.virtual': 'Virtual',
    'public.label.imported': 'Imported',
    'public.label.system': 'System',
    'public.label.url': 'URL',
    'public.label.total': 'Total',
    'public.label.selected': 'Selected',
    'public.label.deselect': 'Deselect',
    'public.label.show_more': 'Show More Items',
    'public.label.default': 'Default',
    'public.label.more': 'More',
    'public.label.show_log': 'Show Log',
    'public.label.hide_log': 'Hide Log',
    'public.label.operation': 'Operation',
    'public.label.enter': 'Please Enter ',
    'public.label.bidding.none': 'Forever',
    'public.label.bidding.3h': '3 hours later',
    'public.label.bidding.6h': '6 hours later',
    'public.label.bidding.24h': '24 hours later',
    'public.label.bidding.48h': '48 hours later',
    'public.label.bidding.72h': '72 hours later',
    'public.label.change.before': 'Change Before',
    'public.label.change.after': 'Change After',
    'public.operation.new': 'New',
    'public.operation.add': 'Add',
    'public.operation.reduce': 'Subtract',
    'public.operation.delete': 'Delete',
    'public.tabs.all': 'All',
    'public.tabs.today': 'Today',
    'public.tabs.last_three': 'Last 3 Days',
    'public.tabs.last_seven': 'Last 7 Days',
    'public.tabs.last_fifteen': 'Last 15 Days',
    'public.tabs.last_thirty': 'Last 30 Days',
    'public.tabs.next_three': 'Next 3 Days',
    'public.tabs.next_seven': 'Next 7 Days',
    'public.tabs.next_fifteen': 'Next 15 Days',
    'public.tabs.more': 'More',
    'public.biz_type.title': 'Business Type',
    'public.biz_type.workbench': 'Workbench',
    'public.biz_type.agent': 'AI Agent',
    'public.biz_type.plan': 'Plan',
    'public.biz_type.request': 'Request',
    'public.biz_type.inquiry': 'Inquiry',
    'public.biz_type.bidding': 'Bidding',
    'public.biz_type.purchase': 'Purchase',
    'public.biz_type.delivery': 'Delivery',
    'public.biz_type.receipt': 'Receipt',
    'public.biz_type.return': 'Return',
    'public.biz_type.inspect': 'Inspection',
    'public.biz_type.defect': 'Defect',
    'public.biz_type.warehouse': 'Warehouse',
    'public.biz_type.inbound': 'Inbound',
    'public.biz_type.outbound': 'Outbound',
    'public.biz_type.stock': 'Stock',
    'public.biz_type.zone': 'Zone',
    'public.biz_type.counting': 'Counting',
    'public.biz_type.finance': 'Finance',
    'public.biz_type.fee': 'Settle',
    'public.biz_type.statement': 'Statement',
    'public.biz_type.payment': 'Payment',
    'public.biz_type.invoice': 'Invoice',
    'public.biz_type.usage': 'Usage',
    'public.biz_type.cost': 'Cost',
    'public.biz_type.product': 'Product',
    'public.biz_type.material': 'Material',
    'public.biz_type.substitute': 'Substitute',
    'public.biz_type.category': 'Category',
    'public.biz_type.bom': 'BOM',
    'public.biz_type.drawing': 'Drawing',
    'public.biz_type.corp': 'Corporation',
    'public.biz_type.general': 'General',
    'public.biz_type.app': 'App',
    'public.biz_type.dept': 'Department',
    'public.biz_type.emp': 'Employee',
    'public.biz_type.role': 'Role',
    'public.biz_type.supplier': 'Supplier',
    'public.biz_type.customer': 'Customer',
    'public.biz_type.label': 'Label',
    'public.biz_type.address': 'Address',
    'public.biz_type.contact': 'Contact',
    'public.biz_type.log': 'Log',
    'public.biz_type.sales': 'Sales',
    'public.biz_type.produce': 'Produce',
    'public.biz_type.work_ticket': 'Work Ticket',
    'public.biz_type.ecn': 'ECN',
    'public.purchase_type.direct': 'Direct Purchase',
    'public.purchase_type.supply': 'Supply Purchase',
    'public.purchase_type.assembly': 'Assembly Purchase',
    'public.purchase_type.process': 'Process Purchase',
    'public.purchase_type.rework': 'Rework Purchase',
    'public.purchase_type.test': 'Test Purchase',
    'public.in_type.purchase': 'Purchase Inbound',
    'public.in_type.sales_return': 'Sales Return Inbound',
    'public.in_type.prod_mat_return': 'Production Material Return Inbound',
    'public.in_type.direct': 'Direct Inbound',
    'public.in_type.fg_in': 'Finished Goods Inbound',
    'public.in_type.loan_return': 'Loan‑Return Inbound',
    'public.in_type.transfer': 'Transfer Inbound',
    'public.in_type.import': 'Import Inbound',
    'public.in_type.sfg_in': 'Semi‑Finished Goods Inbound',
    'public.in_type.disassembly': 'Disassembly Inbound',
    'public.in_type.request_return': 'Request Return Inbound',
    'public.out_type.sales': 'Sales Outbound',
    'public.out_type.purchase_return': 'Purchase Return Outbound',
    'public.out_type.prod_issue': 'Production Issue Outbound',
    'public.out_type.direct': 'Direct Outbound',
    'public.out_type.loan_out': 'Loan‑Out Outbound',
    'public.out_type.transfer': 'Transfer Outbound',
    'public.out_type.prod_rework': 'Production Rework Outbound',
    'public.out_type.disassembly': 'Disassembly Outbound',
    'public.out_type.request_issue': 'Request Issue Outbound',
    'public.stock_flow_type.inbound': 'Inbound',
    'public.stock_flow_type.outbound': 'Outbound',
    'public.stock_flow_type.move': 'Move',
    'public.stock_flow_type.counting': 'Counting',
    'public.stock_flow_type.transfer': 'Transfer',
    'public.stock_flow_type.scrap': 'Scrap',
    'public.stock_flow_type.split': 'Split',
    'public.stock_flow_type.cost_adjust': 'Cost Adjust',
    'public.stock_flow_type.init_import': 'Init Import',
    'public.stock_flow_type.outsource_out': 'Outsource Outbound',
    'public.stock_flow_type.outsource_in': 'Outsource Inbound',
    'public.task_type.approval': 'Approval',
    'public.task_type.remind': 'Remind',
    'public.status.draft': 'Draft',
    'public.status.published': 'Published',
    'public.status.agreed': 'Agreed',
    'public.status.rejected': 'Rejected',
    'public.status.pending': 'Pending',
    'public.status.approved': 'Approved',
    'public.status.declined': 'Declined',
    'public.status.started': 'Started',
    'public.status.paused': 'Paused',
    'public.status.locked': 'Locked',
    'public.status.closed': 'Closed',
    'public.status.completed': 'Completed',
    'public.status.handled': 'Handled',
    'public.status.inactive': 'Inactive',
    'public.status.active': 'Active',
    'public.status.unconfirmed': 'Unconfirmed',
    'public.status.confirmed': 'Confirmed',
    'public.status.delivered': 'Delivered',
    'public.status.received': 'Received',
    'public.status.returning': 'Returning',
    'public.status.returned': 'Returned',
    'public.status.inbound': 'Inbound',
    'public.status.outbound': 'Outbound',
    'public.status.paid': 'Paid',
    'public.status.not_bid': 'Not Bid',
    'public.status.has_bid': 'Has Bid',
    'public.status.unknown': 'Unknown',
    'public.status.unknown.description': 'Unknown Status',
    'public.hint.no_auth': 'No Authorization, Please Contact Admin',
    'public.hint.no_data': 'No Data',
    'public.hint.select.suppliers': 'Please Select Suppliers',
    'public.hint.no.supplier': 'No Supplier Found',
    'public.hint.must.select.items': 'Please Select Items',
    'public.hint.instruction.1': 'Only suppliers with supplier labels covering all item labels are selectable.',
    'public.hint.instruction.2': 'Filter items by label. Single label selection recommended.',
    'public.hint.progress.sync': 'Progress data is synchronized within 15 minutes at most.',
    'public.hint.click_to_edit': 'Click to edit ',
    'public.hint.reject.reason.a': 'Product capacity is insufficient',
    'public.hint.reject.reason.b': 'Purchase item quantity is too low',
    'public.hint.reject.reason.c': 'Unable to meet delivery time',
    'public.hint.reject.reason.d': 'No corresponding specification products',
    'public.label.feedback': 'Feedback',
    'public.label.feedback.other': 'Other Comments',
    'public.label.feedback.description': 'Please Enter the Feedback Description',
    'public.placeholder.all': 'All',
    'public.placeholder.enter': 'Please Enter the ',
    'public.placeholder.select': 'Please Select the ',
    'public.placeholder.required': ' is required',
    'public.placeholder.keyword': 'Please Enter the Keyword',
    'public.placeholder.reject.reason': 'Please Enter the Reject Reason',
    'public.placeholder.decline.reason': 'Please Enter the Decline Reason',
    'public.placeholder.pause.reason': 'Please Enter the Pause Reason',
    'public.placeholder.lock.reason': 'Please Enter the Lock Reason',
    'public.placeholder.supplier_name': 'Please Enter the Supplier Name',
    'public.placeholder.material': 'Please Enter the Material Information',
    'public.placeholder.material_code': 'Please Enter the Material Code',
    'public.placeholder.material_name': 'Please Enter the Material Name',
    'public.placeholder.component': 'Please Enter the Component Information',
    'public.placeholder.subject': 'Please Enter the Subject',
    'public.placeholder.bom_subject': 'Please Enter the BOM Subject',
    'public.placeholder.consignee_name': 'Please Enter the Consignee Name',
    'public.placeholder.order_no': 'Please Enter the Order No',
    'public.placeholder.delivery_no': 'Please Enter the Delivery No',
    'public.placeholder.return_no': 'Please Enter the Return No',
    'public.placeholder.inspect_no': 'Please Enter the Inspect No',
    'public.placeholder.source_no': 'Please Enter the Source No',
    'public.placeholder.target_no': 'Please Enter the Target No',
    'public.placeholder.inbound_no': 'Please Enter the Inbound No',
    'public.placeholder.outbound_no': 'Please Enter the Outbound No',
    'public.placeholder.ticket_no': 'Please Enter the Ticket No',
    'public.placeholder.payment_no': 'Please Enter the Payment No',
    'public.placeholder.customer_name': 'Please Enter the Customer Name',
    'public.placeholder.contract_no': 'Please Enter the Contract No',
    'public.placeholder.material.keyword': 'Please Enter the Material Keyword',
    'public.print.pages': 'Pages',
    'public.print.time': 'Print Time',
    'public.print.index': 'Print Index',
    'public.print.creator': 'Creator',
    'public.print.creator_phone': 'Creator Phone',
    'public.print.signature.shipper': 'Shipper & Handler (Signature)',
    'public.print.signature.consignee': 'Receiver & Handler (Signature)',
    'public.print.copy.stub': '1 Stub (White)',
    'public.print.copy.customer': '2 Customer (Red)',
    'public.print.copy.receipt': '3 Receipt (Blue)',
    'public.print.copy.bookkeeping': '4 Bookkeeping (Yellow)',
    'public.log.remark.request.add': 'Create Request',
    'public.log.remark.request.update': 'Update Request',
    'public.log.remark.request.delete': 'Delete Request',
    'public.log.remark.request.publish': 'Publish Request',
    'public.log.remark.request.revoke': 'Revoke Request',
    'public.log.remark.request.approve': 'Approve Request',
    'public.log.remark.request.decline': 'Decline Request',
    'public.log.remark.request.close': 'Close Request',
    'public.log.remark.purchase.add': 'Create Purchase Order',
    'public.log.remark.purchase.update': 'Update Purchase Order',
    'public.log.remark.purchase.delete': 'Delete Purchase Order',
    'public.log.remark.purchase.publish': 'Publish Purchase Order',
    'public.log.remark.purchase.reject': 'Reject Purchase Order',
    'public.log.remark.purchase.agree': 'Agree Purchase Order',
    'public.log.remark.purchase.approve': 'Approve Purchase Order',
    'public.log.remark.purchase.decline': 'Decline Purchase Order',
    'public.log.remark.purchase.close': 'Close Purchase Order',
    'public.log.remark.purchase.revoke': 'Revoke Purchase Order',
    'public.log.remark.purchase.lock': 'Lock Purchase Order',
    'public.log.remark.purchase.unlock': 'Unlock Purchase Order',
    'public.log.remark.purchase.print': 'Print Purchase Order',
    'public.log.remark.receipt.add': 'Create Delivery',
    'public.log.remark.receipt.publish': 'Publish Delivery',
    'public.log.remark.receipt.reject': 'Reject Delivery',
    'public.log.remark.receipt.agree': 'Agree Delivery',
    'public.log.remark.receipt.revoke': 'Revoke Delivery',
    'public.log.remark.receipt.update': 'Update Delivery',
    'public.log.remark.receipt.delete': 'Delete Delivery',
    'public.log.remark.receipt.print': 'Print Delivery',
    'public.log.remark.return.add': 'Create Return',
    'public.log.remark.return.publish': 'Publish Return',
    'public.log.remark.return.reject': 'Reject Return',
    'public.log.remark.return.agree': 'Agree Return',
    'public.log.remark.return.revoke': 'Revoke Return',
    'public.log.remark.return.update': 'Update Return',
    'public.log.remark.return.delete': 'Delete Return',
    'public.log.remark.return.print': 'Print Return',
    'public.log.remark.inbound.confirm': 'Confirm Inbound',
    'public.log.remark.inbound.revoke': 'Revoke Inbound',
    'public.log.remark.inbound.print': 'Print Inbound',
    'public.log.remark.outbound.confirm': 'Confirm Outbound',
    'public.log.remark.outbound.revoke': 'Revoke Outbound',
    'public.log.remark.outbound.print': 'Print Outbound',
    'public.log.remark.sales.add': 'Create Sales Order',
    'public.log.remark.sales.update': 'Update Sales Order',
    'public.log.remark.sales.delete': 'Delete Sales Order',
    'public.log.remark.sales.publish': 'Publish Sales Order',
    'public.log.remark.sales.revoke': 'Revoke Sales Order',
    'public.log.remark.sales.approve': 'Approve Sales Order',
    'public.log.remark.sales.decline': 'Decline Sales Order',
    'public.log.remark.sales.change': 'Change Sales Order',
    'public.log.remark.sales.print': 'Print Sales Order',
    'public.log.remark.ticket.start': 'Start Work Ticket',
    'public.log.remark.ticket.pause': 'Pause Work Ticket',
    'public.log.remark.ticket.resume': 'Resume Work Ticket',
    'public.log.remark.ticket.close': 'Close Work Ticket',
    'public.log.remark.ticket.complete': 'Complete Work Ticket',
    'public.log.remark.ecn.add': 'Create ECN',
    'public.log.remark.ecn.update': 'Update ECN',
    'public.log.remark.ecn.delete': 'Delete ECN',
    'public.log.remark.ecn.publish': 'Publish ECN',
    'public.log.remark.ecn.revoke': 'Revoke ECN',
    'public.log.remark.ecn.decline': 'Decline ECN',
    'public.log.remark.ecn.approve': 'Approve ECN',
    // 预检弹窗共享文案（完工预检 / 领料预检复用）
    'public.precheck.checked_at': 'Checked at',
    'public.precheck.checking': 'Checking...',
    'public.precheck.detail_note': '{message} (showing first {n})',
    'public.precheck.issued_qty': 'Issued',
    'public.precheck.material': 'Material',
    'public.validate.required': 'This field is required',
    'public.validate.max': 'Cannot exceed {max} characters',
    'public.validate.maxBytes': 'Too long: server limit is {max} bytes (about {maxCjk} Chinese characters)',
    'public.validate.illegal': 'Contains illegal characters',
    'public.validate.html': 'HTML tags are not allowed',
    'public.validate.phone': 'Please enter the correct phone number',
    'public.validate.email': 'Please enter the correct email',
    'public.validate.positive': 'Must be greater than 0',
    'public.validate.amountMax': 'Amount cannot exceed {max}'
  },
  'zh-CN': {
    'public.action.title': '操作',
    'public.action.ok': '确定',
    'public.action.cancel': '取消',
    'public.action.confirm': '确认',
    'public.action.submit': '提交',
    'public.action.reset': '重置',
    'public.action.search': '搜索',
    'public.action.refresh': '刷新',
    'public.action.upload': '上传',
    'public.action.import': '导入',
    'public.action.export': '导出',
    'public.action.print': '打印',
    'public.action.print.draft': '打印草稿',
    'public.action.download': '下载',
    'public.action.template': '下载模板',
    'public.action.open': '打开',
    'public.action.create': '创建',
    'public.action.add': '新建',
    'public.action.delete': '删除',
    'public.action.edit': '编辑',
    'public.action.view': '查看',
    'public.action.publish': '发布',
    'public.action.revoke': '撤销',
    'public.action.agree': '同意',
    'public.action.reject': '拒绝',
    'public.action.approve': '批准',
    'public.action.decline': '驳回',
    'public.action.start': '开始',
    'public.action.pause': '暂停',
    'public.action.resume': '恢复',
    'public.action.lock': '锁定',
    'public.action.unlock': '解锁',
    'public.action.close': '关闭',
    'public.action.complete': '完成',
    'public.action.save': '保存',
    'public.action.copy': '复制',
    'public.action.paste': '粘贴',
    'public.action.revise': '修正',
    'public.action.change': '变更',
    'public.action.archive': '归档',
    'public.action.derive': '派生',
    'public.action.inactive': '禁用',
    'public.action.active': '启用',
    'public.action.inquiry': '询价',
    'public.action.quote': '报价',
    'public.action.delivery': '发货',
    'public.action.move': '移动',
    'public.action.bind': '绑定',
    'public.action.unbind': '解绑',
    'public.action.pick': '拣料',
    'public.action.default': '恢复默认',
    'public.action.use.this': '用这个',
    'public.action.add.items': '添加明细',
    'public.action.issue': '领料',
    'public.action.switch': '切换',
    'public.action.cancel.description': '确定要取消吗？',
    'public.action.delete.description': '确定要删除吗？',
    'public.action.approve.description': '确定要批准吗？',
    'public.action.decline.description': '确定要驳回吗？',
    'public.action.agree.description': '确定要同意吗？',
    'public.action.reject.description': '确定要拒绝吗？',
    'public.action.publish.description': '确定要发布吗？',
    'public.action.revoke.description': '确定要撤销吗？',
    'public.action.start.description': '确定要开始吗？',
    'public.action.pause.description': '确定要暂停吗？',
    'public.action.resume.description': '确定要恢复吗？',
    'public.action.lock.description': '确定要锁定吗？',
    'public.action.unlock.description': '确定要解锁吗？',
    'public.action.close.description': '确定要关闭吗？',
    'public.action.complete.description': '确定要完成吗？',
    'public.action.confirm.description': '确定要执行吗？',
    'public.msg.upload.success': '上传成功',
    'public.msg.upload.failed': '上传失败',
    'public.label.yes': '是',
    'public.label.no': '否',
    'public.label.help': '帮助',
    'public.label.instruction': '说明：',
    'public.label.corporate': '企业',
    'public.label.department': '部门',
    'public.label.role': '角色',
    'public.label.name': '姓名',
    'public.label.email': '邮箱',
    'public.label.phone': '手机',
    'public.label.large': '大',
    'public.label.middle': '中',
    'public.label.small': '小',
    'public.label.field': '字段',
    'public.label.detail': '详情',
    'public.label.index': '行号',
    'public.label.initiator': '发起方',
    'public.label.required': '必填',
    'public.label.priority': '优先级',
    'public.label.success': '成功',
    'public.label.lowest': '最低',
    'public.label.low': '次低',
    'public.label.medium': '中等',
    'public.label.high': '次高',
    'public.label.highest': '最高',
    'public.label.count': '数量',
    'public.label.progress': '进度',
    'public.label.source': '来源',
    'public.label.target': '目标',
    'public.label.warehouse': '仓库',
    'public.label.zone': '分区',
    'public.label.basket': '拣料篮',
    'public.label.lot_no': '批次号',
    'public.label.counting': '盘点',
    'public.label.group': '分组',
    'public.label.mine': '我的',
    'public.label.super_admin': '超级管理员',
    'public.label.stock': '库存',
    'public.label.stock_aging': '库龄（天）',
    'public.label.stock_flow': '库存流水',
    'public.label.keyword': '关键词',
    'public.label.approval': '审批',
    'public.label.approval_detail': '审批详情',
    'public.label.usage': '用途',
    'public.label.payment': '支付',
    'public.label.change': '变更',
    'public.label.summary': '摘要',
    'public.label.statistics': '统计',
    'public.label.app': '应用',
    'public.label.subject': '主题',
    'public.label.bom_subject': 'BOM主题',
    'public.label.component': '组件',
    'public.label.completed': '已完成',
    'public.label.change_type': '变更类型',
    'public.label.start_date': '开始日期',
    'public.label.end_date': '结束日期',
    'public.label.request_date': '需求日期',
    'public.label.owner': '负责人',
    'public.label.creator': '创建者',
    'public.label.operator': '操作者',
    'public.label.confirmer': '确认者',
    'public.label.contact': '联系人',
    'public.label.recipient': '接收方',
    'public.label.consignee': '收货人',
    'public.label.receiver': '接收人',
    'public.label.deliverer': '发货人',
    'public.label.inspector': '质检人',
    'public.label.supplier': '供应商',
    'public.label.purchaser': '采购方',
    'public.label.customer': '客户',
    'public.label.party_name': '供应商/客户',
    'public.label.receiver_party': '接收方',
    'public.label.customer_name': '客户名称',
    'public.label.creator_phone': '创建者手机',
    'public.label.contact_phone': '联系人手机',
    'public.label.consignee_phone': '收货人手机',
    'public.label.ship.address': '收货地址',
    'public.label.address_label': '地址标签',
    'public.label.print_count': '打印次数',
    'public.label.purchase_type': '采购类型',
    'public.label.purchase': '采购',
    'public.label.produce': '生产',
    'public.label.supplier_name': '供应商名称',
    'public.label.short_name': '简称',
    'public.label.level': '等级',
    'public.label.currency': '币种',
    'public.label.payment_method': '支付方式',
    'public.label.payment_term': '支付期限',
    'public.label.tax_rate': '税率',
    'public.label.amount': '未税金额',
    'public.label.tax': '税额',
    'public.label.total_amount': '价税合计',
    'public.label.total_grand': '总计',
    'public.label.fee': '费用',
    'public.label.invoice': '发票',
    'public.label.advance': '预付',
    'public.label.statement': '对账单',
    'public.label.report': '报表',
    'public.label.cost': '成本',
    'public.label.profit': '利润',
    'public.label.margin': '利润率',
    'public.label.unit_price': '单价',
    'public.label.allocation': '分摊',
    'public.label.cost.manufacturing': '制造成本',
    'public.label.cost.labor': '人工成本',
    'public.label.cost.material': '物料成本',
    'public.label.cost.total': '总成本',
    'public.label.cost.unit': '单位成本',
    'public.label.fiscal.period': '会计期间',
    'public.label.contract_date': '合约交期',
    'public.label.feedback_date': '反馈交期',
    'public.label.action_date': '行动截止日',
    'public.label.required_date': '需求日期',
    'public.label.delivery_date': '交货日期',
    'public.label.inbound_date': '入库日期',
    'public.label.outbound_date': '出库日期',
    'public.label.date': '日期',
    'public.label.days': '天',
    'public.label.work_ticket': '工单',
    'public.label.sub_work_ticket': '子工单',
    'public.label.bom_version': 'BOM版本',
    'public.label.finished_product': '产成品',
    'public.label.line_material': '线边物料',
    'public.label.line_issue': '领料',
    'public.label.line_return': '退料',
    'public.label.supplement': '补料',
    'public.label.old_qty': '变更前数量',
    'public.label.new_qty': '变更后数量',
    'public.label.required_qty': '需求数量',
    'public.label.bidding_qty': '竞价数量',
    'public.label.order_qty': '下单数量',
    'public.label.pending_qty': '待处理数量',
    'public.label.total_qty': '总数量',
    'public.label.quantity': '数量',
    'public.label.opening_qty': '期初数量',
    'public.label.change_qty': '变动数量',
    'public.label.closing_qty': '期末数量',
    'public.label.accept_qty': '让步允收',
    'public.label.remaining_qty': '剩余数量',
    'public.label.open_issue_qty': '未领数量',
    'public.label.un_dispatched_qty': '未发数量',
    'public.label.dispatching_qty': '发货数量',
    'public.label.delivered_qty': '已收货数量',
    'public.label.return_pending_qty': '正退回数量',
    'public.label.returned_qty': '已退回数量',
    'public.label.dispatchable_qty': '可发货数量',
    'public.label.received_qty': '实收数量',
    'public.label.return_qty': '退货数量',
    'public.label.inspect_qty': '质检数量',
    'public.label.pass_qty': '合格数量',
    'public.label.fail_qty': '不合格数量',
    'public.label.defect_qty': '不良数量',
    'public.label.reserved_qty': '预扣库存',
    'public.label.stock_qty': '在库数量',
    'public.label.ready_dispatch_qty': '可发数量',
    'public.label.ready_issue_qty': '可领数量',
    'public.label.pick_qty': '拣料数量',
    'public.label.usage_qty': '用量',
    'public.label.shortage_qty': '短缺数量',
    'public.label.inbound_qty': '入库数量',
    'public.label.issued_qty': '已出库数量',
    'public.label.line_qty': '线边数量',
    'public.label.pending_issue_qty': '待出库数量',
    'public.label.shipped_qty': '已发货数量',
    'public.label.pending_ship_qty': '待发货数量',
    'public.label.plan_qty': '计划数量',
    'public.label.rework_qty': '返工数量',
    'public.label.net_output_qty': '净产出量',
    'public.label.produce_qty': '生产数量',
    'public.label.purchase_qty': '采购数量',
    'public.label.safe_qty': '安全数量',
    'public.label.locked_qty': '锁定数量',
    'public.label.system_qty': '系统数量',
    'public.label.actual_qty': '实盘数量',
    'public.label.diff_qty': '差异数量',
    'public.label.actual_usage_qty': '实际用量',
    'public.label.price': '价格',
    'public.label.edit_price': '编辑价格',
    'public.label.preset_price': '预设价格',
    'public.label.unit_price_excl_tax': '未税单价',
    'public.label.unit_price_incl_tax': '含税单价',
    'public.label.tier_price': '阶梯价格',
    'public.label.min_qty': '最小数量',
    'public.label.max_qty': '最大数量',
    'public.label.moq': '最小起订量',
    'public.label.min_lead_time': '最短交期',
    'public.label.lead_time': '提前期',
    'public.label.tier_count': '档位数',
    'public.label.comparison': '比价',
    'public.label.bidding': '竞价',
    'public.label.inquiry': '询价',
    'public.label.quote': '报价',
    'public.label.latest_unit_price': '最新单价',
    'public.label.min_unit_price': '最低单价',
    'public.label.latest_trans': '最近成交',
    'public.label.min_price': '最低成交',
    'public.label.countdown': '倒计时',
    'public.label.deadline': '截止时间',
    'public.label.due_date': '截止日期',
    'public.label.change_reason': '变更原因',
    'public.label.return_reason': '退货原因',
    'public.label.version': '版本号',
    'public.label.target_version': '目标版本号',
    'public.label.version_history': '版本历史',
    'public.label.labels': '标签',
    'public.label.remark': '备注',
    'public.label.status': '状态',
    'public.label.title': '标题',
    'public.label.content': '内容',
    'public.label.context': '上下文',
    'public.label.ip': 'IP',
    'public.label.description': '描述',
    'public.label.delivery_plan': '交货计划',
    'public.label.biz_type': '业务类型',
    'public.label.biz_no': '业务单号',
    'public.label.plan': '计划',
    'public.label.items': '明细',
    'public.label.materials': '物料明细',
    'public.label.contract': '合同',
    'public.label.ecn_no': '工程变更单号',
    'public.label.ticket_no': '工单编号',
    'public.label.contract_no': '合同编号',
    'public.label.request_no': '需求单号',
    'public.label.order_no': '采购单号',
    'public.label.delivery_no': '发货单号',
    'public.label.return_no': '退货单号',
    'public.label.inspect_no': '检验单号',
    'public.label.inbound_no': '入库单号',
    'public.label.outbound_no': '出库单号',
    'public.label.payment_no': '付款单号',
    'public.label.invoice_no': '发票号',
    'public.label.statement_title': '对账单标题',
    'public.label.change_log': '变更日志',
    'public.label.sales_order_no': '销售单号',
    'public.label.link_no': '关联单号',
    'public.label.start_time': '开始时间',
    'public.label.end_time': '结束时间',
    'public.label.created_time': '创建时间',
    'public.label.updated_time': '更新时间',
    'public.label.confirmed_time': '确认时间',
    'public.label.inspected_time': '质检时间',
    'public.label.change_time': '变更时间',
    'public.label.expire_date': '过期日期',
    'public.label.expire_time': '过期时间',
    'public.label.operated_time': '操作时间',
    'public.label.delay': '延迟',
    'public.label.pending.delivery': '待发货',
    'public.label.delivery': '发货',
    'public.label.receipt': '收货',
    'public.label.receipt.history': '收货记录',
    'public.label.return': '退货',
    'public.label.return.history': '退货记录',
    'public.label.inspect': '质检',
    'public.label.inspect.history': '质检记录',
    'public.label.reinspect': '复检',
    'public.label.defect.type': '不良分类',
    'public.label.defect.desc': '不良描述',
    'public.label.defect.images': '不良图片',
    'public.label.defect.report': '不良报告',
    'public.label.inspect.result': '质检结果',
    'public.label.inbound': '入库',
    'public.label.inbound.history': '入库记录',
    'public.label.outbound': '出库',
    'public.label.outbound.history': '出库记录',
    'public.label.inbound.type': '入库类型',
    'public.label.outbound.type': '出库类型',
    'public.label.order.purchase': '采购订单',
    'public.label.order.delivery': '发货单',
    'public.label.order.return': '退货单',
    'public.label.order.inspect': '检验单',
    'public.label.order.inbound': '入库单',
    'public.label.order.outbound': '出库单',
    'public.label.order.payment': '付款单',
    'public.label.order.statement': '对账单',
    'public.label.order.sales': '销售单',
    'public.label.order.request': '需求单',
    'public.label.order.index': '订单行',
    'public.label.supplier_label': '供应商标签',
    'public.label.consolidate': '合并',
    'public.label.deconsolidate': '单列',
    'public.label.category': '分类',
    'public.label.material': '物料信息',
    'public.label.substitute': '替料信息',
    'public.label.material.diff': '物料差异',
    'public.label.material_code': '物料编码',
    'public.label.material_name': '物料名称',
    'public.label.material_spec': '规格型号 / 图号',
    'public.label.material_brand': '材质 / 品牌',
    'public.label.material_unit': '单位',
    'public.label.material_version': '物料版本',
    'public.label.referenced_version': '引用版本',
    'public.label.drawing': '图纸',
    'public.label.drawing_version': '图纸版本',
    'public.label.customer.material_code': '客户物料编码',
    'public.label.customer.material_name': '客户物料名称',
    'public.label.difference': '差异',
    'public.label.new': '新',
    'public.label.deactivated': '已禁用',
    'public.label.activated': '已启用',
    'public.label.enable_mrp': '启用 MRP',
    'public.label.virtual': '虚拟件',
    'public.label.imported': '导入',
    'public.label.system': '系统',
    'public.label.url': '链接',
    'public.label.total': '共',
    'public.label.selected': '已选择',
    'public.label.deselect': '取消选择',
    'public.label.show_more': '显示更多',
    'public.label.default': '默认',
    'public.label.more': '更多',
    'public.label.show_log': '显示日志',
    'public.label.hide_log': '隐藏日志',
    'public.label.operation': '操作',
    'public.label.enter': '请输入',
    'public.label.bidding.none': '无限期',
    'public.label.bidding.3h': '三小时后',
    'public.label.bidding.6h': '六小时后',
    'public.label.bidding.24h': '二十四小时后',
    'public.label.bidding.48h': '四十八小时后',
    'public.label.bidding.72h': '三天后',
    'public.label.change.before': '变更前',
    'public.label.change.after': '变更后',
    'public.operation.new': '新建',
    'public.operation.add': '增加',
    'public.operation.reduce': '减少',
    'public.operation.delete': '删除',
    'public.tabs.all': '全部',
    'public.tabs.today': '今天',
    'public.tabs.last_three': '最近三天',
    'public.tabs.last_seven': '最近七天',
    'public.tabs.last_fifteen': '最近十五天',
    'public.tabs.last_thirty': '最近三十天',
    'public.tabs.next_three': '未来三天',
    'public.tabs.next_seven': '未来七天',
    'public.tabs.next_fifteen': '未来十五天',
    'public.tabs.more': '更多',
    'public.biz_type.title': '业务类型',
    'public.biz_type.workbench': '工作台',
    'public.biz_type.agent': '智能体',
    'public.biz_type.plan': '计划',
    'public.biz_type.request': '需求',
    'public.biz_type.inquiry': '询价',
    'public.biz_type.bidding': '竞价',
    'public.biz_type.purchase': '采购',
    'public.biz_type.delivery': '交付',
    'public.biz_type.receipt': '收货单',
    'public.biz_type.return': '退货单',
    'public.biz_type.inspect': '质检',
    'public.biz_type.defect': '不良',
    'public.biz_type.warehouse': '仓库',
    'public.biz_type.inbound': '入库',
    'public.biz_type.outbound': '出库',
    'public.biz_type.stock': '库存',
    'public.biz_type.zone': '分区',
    'public.biz_type.counting': '盘点',
    'public.biz_type.finance': '财务',
    'public.biz_type.fee': '费用单',
    'public.biz_type.statement': '对账单',
    'public.biz_type.payment': '支付',
    'public.biz_type.invoice': '发票',
    'public.biz_type.usage': '用途',
    'public.biz_type.cost': '成本',
    'public.biz_type.product': '产品',
    'public.biz_type.material': '物料',
    'public.biz_type.substitute': '替料',
    'public.biz_type.category': '分类',
    'public.biz_type.bom': '结构',
    'public.biz_type.drawing': '图纸',
    'public.biz_type.corp': '公司',
    'public.biz_type.general': '通用',
    'public.biz_type.app': '应用',
    'public.biz_type.dept': '部门',
    'public.biz_type.emp': '员工',
    'public.biz_type.role': '角色',
    'public.biz_type.supplier': '供应商',
    'public.biz_type.customer': '客户',
    'public.biz_type.address': '地址',
    'public.biz_type.contact': '联系人',
    'public.biz_type.label': '标签',
    'public.biz_type.log': '日志',
    'public.biz_type.sales': '销售',
    'public.biz_type.produce': '生产',
    'public.biz_type.work_ticket': '工单',
    'public.biz_type.ecn': '工程变更',
    'public.purchase_type.direct': '直接采购',
    'public.purchase_type.supply': '来料加工',
    'public.purchase_type.assembly': '委外组装',
    'public.purchase_type.process': '工序委外',
    'public.purchase_type.rework': '委外返工',
    'public.purchase_type.test': '委外检测',
    'public.in_type.purchase': '采购入库',
    'public.in_type.sales_return': '销售退货入库',
    'public.in_type.prod_mat_return': '生产退料入库',
    'public.in_type.direct': '直接入库',
    'public.in_type.fg_in': '成品入库',
    'public.in_type.loan_return': '还货入库',
    'public.in_type.transfer': '调拨入库',
    'public.in_type.import': '导入入库',
    'public.in_type.sfg_in': '半成品入库',
    'public.in_type.disassembly': '拆解入库',
    'public.in_type.request_return': '需求退货入库',
    'public.out_type.sales': '销售出库',
    'public.out_type.purchase_return': '采购退货',
    'public.out_type.prod_issue': '生产领料出库',
    'public.out_type.direct': '直接出库',
    'public.out_type.loan_out': '借货出库',
    'public.out_type.transfer': '调拨出库',
    'public.out_type.prod_rework': '生产返工出库',
    'public.out_type.disassembly': '拆解出库',
    'public.out_type.request_issue': '需求领料出库',
    'public.stock_flow_type.inbound': '入库',
    'public.stock_flow_type.outbound': '出库',
    'public.stock_flow_type.move': '移库',
    'public.stock_flow_type.counting': '盘点',
    'public.stock_flow_type.transfer': '调拨',
    'public.stock_flow_type.scrap': '报废',
    'public.stock_flow_type.split': '拆分',
    'public.stock_flow_type.cost_adjust': '成本调整',
    'public.stock_flow_type.init_import': '初始导入',
    'public.stock_flow_type.outsource_out': '委外出库',
    'public.stock_flow_type.outsource_in': '委外入库',
    'public.task_type.approval': '审批',
    'public.task_type.remind': '提醒',
    'public.status.draft': '草稿',
    'public.status.published': '已发布',
    'public.status.agreed': '已同意',
    'public.status.rejected': '已拒绝',
    'public.status.pending': '待处理',
    'public.status.approved': '已批准',
    'public.status.declined': '已驳回',
    'public.status.started': '已开始',
    'public.status.paused': '已暂停',
    'public.status.locked': '已锁定',
    'public.status.closed': '已关闭',
    'public.status.completed': '已完成',
    'public.status.handled': '已处理',
    'public.status.inactive': '已禁用',
    'public.status.active': '已启用',
    'public.status.unconfirmed': '未确认',
    'public.status.confirmed': '已确认',
    'public.status.delivered': '已发货',
    'public.status.received': '已收货',
    'public.status.returning': '退货中',
    'public.status.returned': '已退货',
    'public.status.inbound': '已入库',
    'public.status.outbound': '已出库',
    'public.status.paid': '已付款',
    'public.status.not_bid': '未竞价',
    'public.status.has_bid': '已竞价',
    'public.status.unknown': '未知',
    'public.status.unknown.description': '未知状态',
    'public.hint.no_auth': '无权限，请联系管理员',
    'public.hint.no_data': '无数据',
    'public.hint.select.suppliers': '请选择供应商',
    'public.hint.no.supplier': '无匹配供应商',
    'public.hint.must.select.items': '请选择物料项',
    'public.hint.instruction.1': '只有供应商标签涵盖了所有需求项的物料分类才能被选中。',
    'public.hint.instruction.2': '可以尝试按照分类先筛选需求项，建议选择单一分类。',
    'public.hint.progress.sync': '最长十五分钟完成各进度数据的同步',
    'public.hint.click_to_edit': '点击可直接修改',
    'public.hint.reject.reason.a': '产品产能不足',
    'public.hint.reject.reason.b': '采购需求量过低',
    'public.hint.reject.reason.c': '无法满足交付时间',
    'public.hint.reject.reason.d': '暂无对应规格产品',
    'public.label.feedback': '反馈',
    'public.label.feedback.other': '其他说明',
    'public.label.feedback.description': '请输入反馈描述',
    'public.placeholder.all': '全部',
    'public.placeholder.enter': '请输入',
    'public.placeholder.select': '请选择',
    'public.placeholder.required': '为必填项',
    'public.placeholder.keyword': '请输入关键词',
    'public.placeholder.reject.reason': '请输入拒绝原因',
    'public.placeholder.decline.reason': '请输入驳回原因',
    'public.placeholder.pause.reason': '请输入暂停原因',
    'public.placeholder.lock.reason': '请输入锁定原因',
    'public.placeholder.supplier_name': '请输入供应商名称',
    'public.placeholder.material': '请输入物料信息',
    'public.placeholder.material_code': '请输入物料编码',
    'public.placeholder.material_name': '请输入物料名称',
    'public.placeholder.component': '请输入组件信息',
    'public.placeholder.subject': '请输入主题',
    'public.placeholder.bom_subject': '请输入BOM主题',
    'public.placeholder.consignee_name': '请输入收货人名称',
    'public.placeholder.order_no': '请输入订单号',
    'public.placeholder.delivery_no': '请输入发货单号',
    'public.placeholder.return_no': '请输入退货单号',
    'public.placeholder.inspect_no': '请输入检验单号',
    'public.placeholder.source_no': '请输入来源编号',
    'public.placeholder.target_no': '请输入目标编号',
    'public.placeholder.inbound_no': '请输入入库单号',
    'public.placeholder.outbound_no': '请输入出库单号',
    'public.placeholder.ticket_no': '请输入工单号',
    'public.placeholder.payment_no': '请输入付款单号',
    'public.placeholder.customer_name': '请输入客户名称',
    'public.placeholder.contract_no': '请输入合同编号',
    'public.placeholder.material.keyword': '请输入物料编码、名称、规格型号/图号、材质/品牌等关键词',
    'public.print.pages': '页',
    'public.print.time': '打印时间',
    'public.print.index': '打印序号',
    'public.print.creator': '创建人',
    'public.print.creator_phone': '创建人手机',
    'public.print.signature.shipper': '发货方及经手人(签章)',
    'public.print.signature.consignee': '收货方及经手人(签章)',
    'public.print.copy.stub': '1 存根(白)',
    'public.print.copy.customer': '2 客户(红)',
    'public.print.copy.receipt': '3 回单(蓝)',
    'public.print.copy.bookkeeping': '4 记账(黄)',
    'public.log.remark.request.add': '新建需求单',
    'public.log.remark.request.update': '更新需求单',
    'public.log.remark.request.delete': '删除需求单',
    'public.log.remark.request.publish': '发布需求单',
    'public.log.remark.request.revoke': '撤销需求单',
    'public.log.remark.request.approve': '批准需求单',
    'public.log.remark.request.decline': '驳回需求单',
    'public.log.remark.request.close': '关闭需求单',
    'public.log.remark.purchase.add': '新建采购订单',
    'public.log.remark.purchase.update': '更新采购订单',
    'public.log.remark.purchase.delete': '删除采购订单',
    'public.log.remark.purchase.publish': '发布采购订单',
    'public.log.remark.purchase.reject': '拒绝采购订单',
    'public.log.remark.purchase.agree': '同意采购订单',
    'public.log.remark.purchase.approve': '批准采购订单',
    'public.log.remark.purchase.decline': '驳回采购订单',
    'public.log.remark.purchase.close': '关闭采购订单',
    'public.log.remark.purchase.revoke': '撤销采购订单',
    'public.log.remark.purchase.lock': '锁定采购订单',
    'public.log.remark.purchase.unlock': '解锁采购订单',
    'public.log.remark.purchase.print': '打印采购订单',
    'public.log.remark.receipt.add': '新建发货单',
    'public.log.remark.receipt.publish': '发布发货单',
    'public.log.remark.receipt.reject': '拒绝发货单',
    'public.log.remark.receipt.agree': '同意发货单',
    'public.log.remark.receipt.revoke': '撤销发货单',
    'public.log.remark.receipt.update': '更新发货单',
    'public.log.remark.receipt.delete': '删除发货单',
    'public.log.remark.receipt.print': '打印发货单',
    'public.log.remark.return.add': '新建退货单',
    'public.log.remark.return.publish': '发布退货单',
    'public.log.remark.return.reject': '拒绝退货单',
    'public.log.remark.return.agree': '同意退货单',
    'public.log.remark.return.revoke': '撤销退货单',
    'public.log.remark.return.update': '更新退货单',
    'public.log.remark.return.delete': '删除退货单',
    'public.log.remark.return.print': '打印退货单',
    'public.log.remark.inbound.add': '新建入库单',
    'public.log.remark.inbound.publish': '发布入库单',
    'public.log.remark.inbound.reject': '拒绝入库单',
    'public.log.remark.inbound.agree': '同意入库单',
    'public.log.remark.inbound.revoke': '撤销入库单',
    'public.log.remark.inbound.update': '更新入库单',
    'public.log.remark.inbound.delete': '删除入库单',
    'public.log.remark.inbound.print': '打印入库单',
    'public.log.remark.outbound.add': '新建出库单',
    'public.log.remark.outbound.publish': '发布出库单',
    'public.log.remark.outbound.reject': '拒绝出库单',
    'public.log.remark.outbound.agree': '同意出库单',
    'public.log.remark.outbound.revoke': '撤销出库单',
    'public.log.remark.outbound.update': '更新出库单',
    'public.log.remark.outbound.delete': '删除出库单',
    'public.log.remark.outbound.print': '打印出库单',
    'public.log.remark.sales.add': '新建销售单',
    'public.log.remark.sales.update': '更新销售单',
    'public.log.remark.sales.delete': '删除销售单',
    'public.log.remark.sales.publish': '发布销售单',
    'public.log.remark.sales.revoke': '撤销销售单',
    'public.log.remark.sales.approve': '批准销售单',
    'public.log.remark.sales.decline': '驳回销售单',
    'public.log.remark.sales.change': '变更销售单',
    'public.log.remark.sales.print': '打印销售单',
    'public.log.remark.ticket.start': '启动工单',
    'public.log.remark.ticket.pause': '暂停工单',
    'public.log.remark.ticket.resume': '恢复工单',
    'public.log.remark.ticket.close': '关闭工单',
    'public.log.remark.ticket.complete': '完成工单',
    'public.log.remark.ecn.add': '新建工程变更单',
    'public.log.remark.ecn.update': '更新工程变更单',
    'public.log.remark.ecn.delete': '删除工程变更单',
    'public.log.remark.ecn.publish': '发布工程变更单',
    'public.log.remark.ecn.revoke': '撤销工程变更单',
    'public.log.remark.ecn.decline': '驳回工程变更单',
    'public.log.remark.ecn.approve': '批准工程变更单',
    'public.precheck.checked_at': '预检时间',
    'public.precheck.checking': '检查中…',
    'public.precheck.detail_note': '{message}（仅展示前 {n} 条）',
    'public.precheck.issued_qty': '已领',
    'public.precheck.material': '物料',
    'public.validate.required': '此项为必填项',
    'public.validate.max': '不能超过 {max} 个字符',
    'public.validate.maxBytes': '内容过长：服务端上限 {max} 字节（约 {maxCjk} 个汉字）',
    'public.validate.illegal': '包含非法字符',
    'public.validate.html': '不能包含 HTML 标签',
    'public.validate.phone': '请输入正确的手机号',
    'public.validate.email': '请输入正确的邮箱',
    'public.validate.positive': '必须大于 0',
    'public.validate.amountMax': '金额不能超过 {max}'
  }
};
export default i18n;